import React from 'react';
import SparklineWidget from './SparklineWidget';
import ComparisonWidget from './ComparisonWidget';
import ClockWidget from './ClockWidget';
import NoteWidget from './NoteWidget';
import AlertFeedWidget from './AlertFeedWidget';
import KpiGridWidget from './KpiGridWidget';
import EnergyFlowWidget from './EnergyFlowWidget';
import WeatherWidget from './WeatherWidget';
import MaintenanceTicketsWidget from './MaintenanceTicketsWidget';
import LeaderboardWidget from './LeaderboardWidget';
import HealthScoreWidget from './HealthScoreWidget';
import ThreeDWidget from './ThreeDWidget';
import { THREE_D_IDS } from '../extraVariants';

const MISC_COMPONENTS = {
    sparkline: SparklineWidget,
    comparison: ComparisonWidget,
    clock: ClockWidget,
    note: NoteWidget,
    'alert-feed': AlertFeedWidget,
    'kpi-grid': KpiGridWidget,
    'energy-flow': EnergyFlowWidget,
    weather: WeatherWidget,
    'maintenance-tickets': MaintenanceTicketsWidget,
    leaderboard: LeaderboardWidget,
    'health-score': HealthScoreWidget,
};

const ExtraWidget = ({ config }) => {
    const variant = config.variant || 'sparkline';

    if (THREE_D_IDS.includes(variant)) {
        return <ThreeDWidget config={config} />;
    }

    const Component = MISC_COMPONENTS[variant] || SparklineWidget;
    return <Component config={config} />;
};

export default ExtraWidget;
